// --------------Header-logo---------------

export const BlockboltLogo = () => {
  return (
    <svg
      width="250"
      height="33"
      viewBox="0 0 250 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.207 3.40332H44.0945V23.8734H56.5745V29.5968H38.207V3.40332Z"
        fill="#00142F"
      />
      <path
        d="M60.5977 16.5003C60.5977 10.0262 63.7652 2.95264 72.2227 2.95264C80.6402 2.95264 83.7701 10.0262 83.7701 16.5003C83.7701 22.9743 80.6402 30.0479 72.2227 30.0479C63.7652 30.0479 60.5977 22.9743 60.5977 16.5003ZM77.6602 16.5003C77.6602 12.9081 76.3577 8.64073 72.2227 8.64073C68.0127 8.64073 66.7077 13.0945 66.7077 16.5003C66.7077 20.027 68.0877 24.322 72.2227 24.322C76.2077 24.322 77.6602 19.901 77.6602 16.5003Z"
        fill="#00142F"
      />
      <path
        d="M91.0352 16.4998C91.0352 10.5497 93.9027 3.02775 102.063 3.02775C104.128 2.99363 106.154 3.59024 107.876 4.73907C109.599 5.88791 110.935 7.53514 111.71 9.46401L106.46 11.8219C105.158 9.83936 104.04 8.71585 102.065 8.71585C98.3402 8.71585 97.1476 13.0184 97.1476 16.4998C97.1476 20.092 98.6002 24.2838 102.065 24.2838C103.853 24.2838 105.195 22.8983 106.388 20.9158L111.75 22.931C109.85 27.0472 106.87 29.9668 102.065 29.9668C93.8302 29.9769 91.0352 22.9739 91.0352 16.4998Z"
        fill="#00142F"
      />
      <path
        d="M130.153 17.9206L125.153 24.2184V29.6067H119.275V3.4082H125.16V15.7517L134.883 3.4082H141.963L134.138 12.9505L143.303 29.6016H136.41L130.153 17.9206Z"
        fill="#00142F"
      />
      <path
        d="M161.072 3.40348C167.294 3.40348 169.307 6.84454 169.307 10.399C169.307 12.5704 168.114 14.6663 165.729 15.8276C168.979 16.9864 170.229 19.4929 170.229 21.9263C170.229 25.4807 167.994 29.5969 161.624 29.5969H151.199V3.39844L161.072 3.40348ZM165.357 10.5803C165.357 8.89508 164.649 6.98813 161.184 6.98813H155.074V14.2179H160.439C163.717 14.2179 165.357 12.7216 165.357 10.5803ZM166.289 22.1052C166.289 19.8984 165.209 17.8026 160.812 17.8026H155.062V25.9971H161.917C165.357 26.0047 166.289 23.9466 166.289 22.1127V22.1052Z"
        fill="#00142F"
      />
      <path
        d="M210.66 3.40332H214.533V25.8559H227.283V29.5968H210.66V3.40332Z"
        fill="#00142F"
      />
      <path
        d="M242.623 29.5968H238.751V7.14416H231.373V3.40332H250.001V7.14416H242.623V29.5968Z"
        fill="#00142F"
      />
      <path
        d="M185.358 29.239C180.336 27.2061 178.436 21.6641 178.436 16.4999C178.436 10.0259 181.416 2.95231 189.798 2.95231C190.732 2.94759 191.663 3.04643 192.576 3.24704L181.326 17.9912H189.123L185.358 29.239ZM194.251 3.76094L193.846 4.96254L190.466 15.0086H198.263L190.533 25.1454L187.033 29.7554C187.946 29.954 188.877 30.052 189.811 30.0476C198.191 30.0476 201.173 22.974 201.173 16.4999C201.161 11.3358 199.251 5.79384 194.251 3.76094Z"
        fill="url(#paint0_linear_248_571)"
      />
      <path
        d="M26.585 15.9382C28.7825 14.9306 29.4525 12.8322 29.4525 10.5121C29.4525 6.95771 27.2925 3.40328 20.81 3.40328H8.2175V8.94527H20.8475C23.0825 8.94527 23.455 10.1444 23.455 11.2276C23.455 12.6508 22.4875 13.5476 20.2525 13.5476H8.2175V29.6018H21.295C27.925 29.6018 30.31 25.5712 30.31 21.7447C30.31 19.6816 29.305 16.9862 26.585 15.9382ZM21.555 24.022H14.105V18.8579H20.55C23.715 18.8579 24.35 20.2786 24.35 21.5885C24.35 22.6365 23.68 24.022 21.555 24.022ZM20.9575 0V3.40328H17.57V0H20.9575ZM20.9575 29.5967V33H17.57V29.5967H20.9575ZM9.4575 6.76122H7V4.28244H9.45L9.4575 6.76122ZM6.225 16.1776H3.765V13.7038H6.225V16.1776ZM4.3175 11.084H2.9625V9.72366H4.3175V11.084ZM5 7.08618H4.3175V6.40603H5V7.08618ZM1.015 6.74611H0V5.72588H1.015V6.74611ZM2.015 13.2302H0.3325V11.5298H2.025L2.015 13.2302ZM7.115 9.99572H5.42V8.29534H7.115V9.99572ZM1.865 9.14427H0.5V7.78397H1.855L1.865 9.14427Z"
        fill="url(#paint1_linear_248_571)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_248_571"
          x1="178.436"
          y1="16.4999"
          x2="201.161"
          y2="16.4999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02F4D2" />
          <stop offset="1" stopColor="#6C17FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_248_571"
          x1="30.31"
          y1="16.5"
          x2="0"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C17FC" />
          <stop offset="1" stopColor="#02F4D2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// --------------Header-icons---------------

export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79292 0.417893C10.1834 0.0273689 10.8166 0.0273689 11.2071 0.417893L20.5821 9.79289C20.8681 10.0789 20.9537 10.509 20.7989 10.8827C20.6441 11.2564 20.2795 11.5 19.875 11.5H18.7918L18.7921 14.6458L18.7923 17.7916C18.7923 18.6093 18.4675 19.3937 17.8893 19.9719C17.311 20.5501 16.5268 20.875 15.709 20.875H5.29235C4.47459 20.875 3.69034 20.5501 3.1121 19.9719C2.53388 19.3937 2.20904 18.6095 2.20901 17.7918L2.20845 11.5H1.12503C0.720567 11.5 0.355931 11.2564 0.20115 10.8827C0.0463687 10.509 0.131924 10.0789 0.417922 9.79289L9.79292 0.417893ZM3.49697 9.54228C3.90852 9.66612 4.20832 10.048 4.20836 10.4999L4.20901 17.7916C4.20901 18.0789 4.32315 18.3545 4.52631 18.5577C4.72948 18.7609 5.00503 18.875 5.29235 18.875H6.37503V13.6248C6.37503 12.8071 6.69988 12.0228 7.27812 11.4446C7.85635 10.8664 8.64061 10.5415 9.45836 10.5415H11.5417C12.3594 10.5415 13.1437 10.8664 13.7219 11.4446C14.3002 12.0228 14.625 12.8071 14.625 13.6248V18.875H15.709C15.9963 18.875 16.2719 18.7609 16.475 18.5577C16.6782 18.3545 16.7923 18.079 16.7923 17.7917L16.7917 10.5001C16.7917 10.2349 16.897 9.98048 17.0846 9.79292C17.2024 9.67509 17.3466 9.58969 17.5033 9.54249L10.5 2.53921L3.49697 9.54228ZM12.625 18.875V13.6248C12.625 13.3375 12.5109 13.062 12.3077 12.8588C12.1046 12.6556 11.829 12.5415 11.5417 12.5415H9.45836C9.17105 12.5415 8.8955 12.6556 8.69233 12.8588C8.48917 13.062 8.37503 13.3375 8.37503 13.6248V18.875H12.625Z"
        fill="#333333"
      />
    </svg>
  );
};
export const PosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M4.83211 1.87377C5.22263 1.48325 5.22263 0.850084 4.83211 0.459559C4.44158 0.069035 3.80842 0.069035 3.41789 0.459559L0.292893 3.58456C-0.0976311 3.97508 -0.0976311 4.60825 0.292893 4.99877L3.41789 8.12377C3.80842 8.5143 4.44158 8.5143 4.83211 8.12377C5.22263 7.73325 5.22263 7.10008 4.83211 6.70956L3.41421 5.29167H20.75C21.3023 5.29167 21.75 4.84395 21.75 4.29167C21.75 3.73938 21.3023 3.29167 20.75 3.29167H3.41421L4.83211 1.87377Z"
        fill="#333333"
      />
      <path
        d="M18.3321 10.8762C17.9416 10.4857 17.3084 10.4857 16.9179 10.8762C16.5274 11.2668 16.5274 11.8999 16.9179 12.2904L18.3358 13.7083H1C0.447715 13.7083 0 14.156 0 14.7083C0 15.2606 0.447715 15.7083 1 15.7083H18.3358L16.9179 17.1262C16.5274 17.5168 16.5274 18.1499 16.9179 18.5404C17.3084 18.931 17.9416 18.931 18.3321 18.5404L21.4571 15.4154C21.8476 15.0249 21.8476 14.3918 21.4571 14.0012L18.3321 10.8762Z"
        fill="#333333"
      />
    </svg>
  );
};
export const PaylinksIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8762 1.50123C11.7544 0.623022 12.9455 0.129652 14.1875 0.129652C15.4295 0.129652 16.6206 0.623022 17.4988 1.50123C18.377 2.37943 18.8703 3.57053 18.8703 4.8125C18.8703 6.05447 18.377 7.24557 17.4988 8.12377L13.3355 12.287C12.9037 12.7267 12.3887 13.0761 11.8206 13.3148C11.2508 13.5543 10.6389 13.6776 10.0208 13.6776C9.40275 13.6776 8.79089 13.5543 8.22107 13.3148C7.65125 13.0754 7.13494 12.7247 6.70238 12.2832C6.31586 11.8887 6.32232 11.2556 6.71681 10.869C7.1113 10.4825 7.74443 10.489 8.13095 10.8835C8.3773 11.1349 8.67134 11.3347 8.99586 11.471C9.32037 11.6074 9.66883 11.6776 10.0208 11.6776C10.3728 11.6776 10.7213 11.6074 11.0458 11.471C11.3703 11.3347 11.6644 11.1349 11.9107 10.8835L11.9179 10.8762L11.9179 10.8762L16.0846 6.70956C16.5877 6.20643 16.8703 5.52404 16.8703 4.8125C16.8703 4.10096 16.5877 3.41857 16.0846 2.91544C15.5814 2.41231 14.899 2.12965 14.1875 2.12965C13.476 2.12965 12.7936 2.41231 12.2904 2.91544L11.7696 3.43627C11.3791 3.8268 10.7459 3.8268 10.3554 3.43627C9.96487 3.04575 9.96487 2.41258 10.3554 2.02206L10.8762 1.50123ZM7.17941 5.68516C7.74922 5.44572 8.36109 5.32238 8.97917 5.32238C9.59725 5.32238 10.2091 5.44572 10.7789 5.68516C11.3487 5.92459 11.8651 6.27533 12.2976 6.71681C12.6841 7.1113 12.6777 7.74443 12.2832 8.13095C11.8887 8.51747 11.2556 8.51101 10.869 8.11652C10.6227 7.86509 10.3287 7.66535 10.0041 7.52899C9.67963 7.39262 9.33117 7.32238 8.97917 7.32238C8.62717 7.32238 8.27871 7.39262 7.95419 7.52899C7.62968 7.66535 7.33564 7.86509 7.08929 8.11652L7.08215 8.12381L7.08211 8.12377L2.91544 12.2904C2.41231 12.7936 2.12965 13.476 2.12965 14.1875C2.12965 14.899 2.41231 15.5814 2.91544 16.0846C3.41857 16.5877 4.10097 16.8703 4.8125 16.8703C5.52404 16.8703 6.20643 16.5877 6.70956 16.0846L7.23039 15.5637C7.62092 15.1732 8.25408 15.1732 8.64461 15.5637C9.03513 15.9543 9.03513 16.5874 8.64461 16.9779L8.12377 17.4988C7.24557 18.377 6.05447 18.8703 4.8125 18.8703C3.57053 18.8703 2.37943 18.377 1.50123 17.4988C0.623024 16.6206 0.129654 15.4295 0.129654 14.1875C0.129654 12.9455 0.623024 11.7544 1.50123 10.8762L5.66449 6.71296C6.09629 6.27329 6.61125 5.9239 7.17941 5.68516Z"
        fill="#333333"
      />
    </svg>
  );
};
export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8144 7.75288C18.8618 7.76728 18.9091 7.78169 18.9558 7.79742C20.1347 8.19456 20.8 9.2057 20.8 10.3C20.8 11.5053 20.1123 12.5387 18.976 12.9219C18.7984 12.9818 18.6125 13.0455 18.4581 13.1517C18.4387 13.165 18.4194 13.1806 18.4 13.2C18.2284 13.3716 18.1064 13.6093 18.1004 13.8518C18.1 13.8682 18.1 13.8841 18.1 13.9C18.1 14.1003 18.1937 14.2756 18.2884 14.453C18.3275 14.5262 18.3668 14.5998 18.3998 14.6756C18.8471 15.7041 18.6003 16.8997 17.8 17.7C16.9 18.6 15.5 18.8 14.4 18.1C14.2 18 14.1 18 14 18L13.9528 18.0001C13.7078 18.0018 13.4733 18.1267 13.3 18.3C13.1697 18.4303 13.1096 18.6039 13.0491 18.7788C13.0291 18.8365 13.009 18.8943 12.9864 18.9508C12.5777 19.9712 11.5698 20.7 10.4 20.7C9.22008 20.7 8.20493 20.041 7.80315 18.9472C7.78557 18.8994 7.76927 18.8499 7.75285 18.8001C7.69298 18.6183 7.63142 18.4314 7.5 18.3C7.4679 18.2679 7.43579 18.2358 7.4037 18.207C7.29164 18.1065 7.15051 18 7 18C6.89999 18 6.60001 18.1 6.39999 18.2C5.3 18.9 3.89999 18.7 3 17.8C2.10001 16.9 1.89999 15.5 2.60001 14.4C2.65265 14.2947 2.67758 14.2448 2.68938 14.1921C2.7 14.1446 2.7 14.0947 2.7 14C2.7 13.8828 2.66568 13.8 2.63725 13.7314C2.61716 13.6828 2.60001 13.6414 2.60001 13.6C2.60001 13.5 2.5 13.4 2.39999 13.3C2.3 13.2 2.2 13.1 2.10001 13.1C0.899994 12.8 0 11.7 0 10.4C0 9.14452 0.839401 8.07558 1.97778 7.73362C2.05846 7.70938 2.13721 7.67891 2.21564 7.64817L2.22205 7.64569C2.33228 7.60324 2.46663 7.5445 2.53751 7.45C2.60837 7.3555 2.65413 7.25176 2.68033 7.13658C2.7 7.05012 2.7 6.95815 2.7 6.9C2.7 6.69894 2.60844 6.52075 2.51602 6.34089C2.47853 6.26792 2.4409 6.19467 2.40918 6.11951C1.94966 5.03055 2.19441 3.8951 3 3C3.9369 2.15679 5.13713 1.92803 6.27174 2.47819C6.33672 2.5097 6.39719 2.55042 6.45755 2.59107C6.54079 2.64713 6.62384 2.70307 6.71831 2.73456C6.88333 2.78957 7.06459 2.76771 7.2 2.7C7.39999 2.6 7.60001 2.4 7.7 2.1C8 0.9 9.10001 0 10.4 0C11.5695 0 12.5772 0.728437 12.9133 1.74842C12.9285 1.79454 12.9425 1.84223 12.9567 1.89036C13.0112 2.07583 13.0677 2.26768 13.2 2.4C13.3671 2.56705 13.6104 2.69506 13.8466 2.69962C13.8663 2.7 13.8844 2.7 13.9 2.7C14.1003 2.7 14.2756 2.60635 14.4529 2.51161C14.5262 2.47248 14.5998 2.43317 14.6756 2.40019C15.7041 1.95292 16.8997 2.19972 17.7 3C18.6 4 18.8 5.3 18.1 6.4C18 6.6 18 6.7 18 6.8C18 6.81562 18 6.83369 18.0004 6.85343C18.0049 7.08962 18.1329 7.33295 18.3 7.5C18.4386 7.63861 18.6261 7.69561 18.8144 7.75288ZM16.9 11.7C17.3 11.4 17.7 11.2 18.1 11.1C18.7 11 18.8 10.5 18.8 10.4C18.8 10.2 18.8 9.7 18.2 9.6C17.7 9.5 17.3 9.3 17 9C16.6 8.7 16.4 8.4 16.2 8C16 7.6 16 7.1 16 6.7C16 6.2 16.2 5.8 16.5 5.5C16.8 5 16.5 4.6 16.4 4.5C16.3 4.4 15.9 4.1 15.4 4.4C15.1 4.6 14.6 4.8 14.2 4.8C13.7 4.8 13.3 4.8 12.9 4.6C12.4 4.4 12.1 4.1 11.8 3.8C11.5 3.4 11.3 3 11.2 2.6C11 2 10.5 2 10.4 2C10.2 2 9.7 2 9.60001 2.6C9.39999 3.5 8.8 4.2 8 4.5C7.10001 4.9 6.2 4.8 5.39999 4.4C4.89999 4.1 4.5 4.4 4.39999 4.5C4.3 4.6 4 5 4.3 5.5C4.5 5.8 4.7 6.3 4.7 6.7C4.7 7.1 4.7 7.6 4.5 8C4.39999 8.4 4.10001 8.7 3.8 9C3.39999 9.3 3 9.5 2.60001 9.6C2 9.8 2 10.3 2 10.4C2 10.5 2 11 2.60001 11.1C3.10001 11.2 3.5 11.4 3.8 11.7C4.19997 12 4.39996 12.4 4.59996 12.7999L4.60001 12.8C4.8 13.2 4.8 13.7 4.8 14.1C4.8 14.5 4.60001 14.9 4.39999 15.3C4.10001 15.8 4.39999 16.2 4.5 16.3C4.60001 16.4 5 16.7 5.5 16.4C5.8 16.2 6.3 16 6.7 16H6.89999C7.2 16 7.60001 16.1 7.89999 16.2C8.39999 16.4 8.7 16.7 9 17C9.16022 17.1602 9.2919 17.3489 9.37984 17.5662C9.43057 17.6915 9.46252 17.8297 9.4942 17.9667C9.56325 18.2652 9.631 18.5581 9.88901 18.7005C10.0694 18.8 10.2451 18.8 10.3 18.8C10.5 18.8 11 18.8 11.1 18.2C11.2 17.7 11.4 17.3 11.7 17C12 16.6 12.4 16.4 12.8 16.2C13.2 16 13.7 16 14.1 16C14.5 16 14.9 16.2 15.3 16.4C15.8 16.7 16.2 16.4 16.3 16.3C16.4 16.2 16.7 15.8 16.4 15.3C16.2 15 16 14.5 16 14.1C16 13.6 16 13.2 16.1 12.8C16.3 12.3 16.6 12 16.8999 11.7L16.9 11.7ZM6.3 10.4C6.3 8.2 8.10001 6.3 10.4 6.3C12.6 6.3 14.5 8.2 14.5 10.4C14.5 12.6 12.6 14.5 10.4 14.5C8.2 14.5 6.3 12.6 6.3 10.4ZM8.3 10.4C8.3 11.5 9.2 12.5 10.4 12.5C11.5 12.5 12.5 11.5 12.5 10.4C12.5 9.3 11.5 8.3 10.4 8.3C9.3 8.3 8.3 9.3 8.3 10.4Z"
        fill="#333333"
      />
    </svg>
  );
};

export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02809 1.06975C1.60632 0.491516 2.39058 0.166666 3.20833 0.166666H10.5C11.3178 0.166666 12.102 0.491517 12.6802 1.06975C13.2585 1.64799 13.5833 2.43225 13.5833 3.25V5.33333C13.5833 5.88562 13.1356 6.33333 12.5833 6.33333C12.031 6.33333 11.5833 5.88562 11.5833 5.33333V3.25C11.5833 2.96268 11.4692 2.68713 11.266 2.48397C11.0629 2.2808 10.7873 2.16667 10.5 2.16667H3.20833C2.92102 2.16667 2.64547 2.2808 2.4423 2.48397C2.23914 2.68713 2.125 2.96268 2.125 3.25V15.75C2.125 16.0373 2.23914 16.3129 2.4423 16.516C2.64547 16.7192 2.92102 16.8333 3.20833 16.8333H10.5C10.7873 16.8333 11.0629 16.7192 11.266 16.516C11.4692 16.3129 11.5833 16.0373 11.5833 15.75V13.6667C11.5833 13.1144 12.031 12.6667 12.5833 12.6667C13.1356 12.6667 13.5833 13.1144 13.5833 13.6667V15.75C13.5833 16.5678 13.2585 17.352 12.6802 17.9302C12.102 18.5085 11.3178 18.8333 10.5 18.8333H3.20833C2.39058 18.8333 1.60632 18.5085 1.02809 17.9302C0.44985 17.352 0.125 16.5678 0.125 15.75V3.25C0.125 2.43225 0.44985 1.64799 1.02809 1.06975ZM16.0429 5.66789C16.4334 5.27737 17.0666 5.27737 17.4571 5.66789L20.5821 8.79289C20.9726 9.18342 20.9726 9.81658 20.5821 10.2071L17.4571 13.3321C17.0666 13.7226 16.4334 13.7226 16.0429 13.3321C15.6524 12.9416 15.6524 12.3084 16.0429 11.9179L17.4608 10.5H5.29167C4.73939 10.5 4.29167 10.0523 4.29167 9.5C4.29167 8.94772 4.73939 8.5 5.29167 8.5H17.4608L16.0429 7.08211C15.6524 6.69158 15.6524 6.05842 16.0429 5.66789Z"
        fill="#333333"
      />
    </svg>
  );
};
// --------------dashboard-header-icons---------------

export const BalanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="22"
      viewBox="0 0 14 22"
      fill="none"
    >
      <path
        d="M6.08523 21.8182V0H7.48295V21.8182H6.08523ZM10.1165 6.98011C10.0369 6.2358 9.7017 5.65625 9.1108 5.24148C8.52557 4.82671 7.7642 4.61932 6.8267 4.61932C6.16761 4.61932 5.60227 4.71875 5.13068 4.91761C4.65909 5.11648 4.2983 5.38636 4.0483 5.72727C3.7983 6.06818 3.67045 6.45739 3.66477 6.89489C3.66477 7.25852 3.74716 7.57386 3.91193 7.84091C4.08239 8.10796 4.3125 8.33523 4.60227 8.52273C4.89205 8.70455 5.21307 8.85796 5.56534 8.98296C5.91761 9.10796 6.27273 9.21307 6.63068 9.2983L8.26705 9.70739C8.92614 9.8608 9.55966 10.0682 10.1676 10.3295C10.7812 10.5909 11.3295 10.9205 11.8125 11.3182C12.3011 11.7159 12.6875 12.196 12.9716 12.7585C13.2557 13.321 13.3977 13.9801 13.3977 14.7358C13.3977 15.7585 13.1364 16.6591 12.6136 17.4375C12.0909 18.2102 11.3352 18.8153 10.3466 19.2528C9.36364 19.6847 8.1733 19.9006 6.77557 19.9006C5.41761 19.9006 4.23864 19.6903 3.23864 19.2699C2.24432 18.8494 1.46591 18.2358 0.903409 17.429C0.346591 16.6222 0.0454546 15.6392 0 14.4801H3.1108C3.15625 15.0881 3.34375 15.5938 3.6733 15.9972C4.00284 16.4006 4.43182 16.7017 4.96023 16.9006C5.49432 17.0994 6.09091 17.1989 6.75 17.1989C7.4375 17.1989 8.03977 17.0966 8.55682 16.892C9.07955 16.6818 9.48864 16.392 9.78409 16.0227C10.0795 15.6477 10.2301 15.2102 10.2358 14.7102C10.2301 14.2557 10.0966 13.8807 9.83523 13.5852C9.57386 13.2841 9.20739 13.0341 8.7358 12.8352C8.26989 12.6307 7.72443 12.4489 7.09943 12.2898L5.11364 11.7784C3.67614 11.4091 2.53977 10.8494 1.70455 10.0994C0.875 9.34375 0.460227 8.34091 0.460227 7.09091C0.460227 6.0625 0.738636 5.16193 1.29545 4.38921C1.85795 3.61648 2.62216 3.01705 3.58807 2.59091C4.55398 2.15909 5.64773 1.94318 6.86932 1.94318C8.10795 1.94318 9.19318 2.15909 10.125 2.59091C11.0625 3.01705 11.7983 3.6108 12.3324 4.37216C12.8665 5.12784 13.142 5.99716 13.1591 6.98011H10.1165Z"
        fill="white"
      />
    </svg>
  );
};
export const DocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
    >
      <path
        d="M3.60511 12.5625V12.3409C3.6108 11.3125 3.70739 10.4943 3.89489 9.88636C4.08807 9.27841 4.3608 8.78977 4.71307 8.42045C5.06534 8.04545 5.49432 7.7017 6 7.3892C6.34659 7.1733 6.65625 6.9375 6.92898 6.68182C7.20739 6.42045 7.42614 6.13068 7.58523 5.8125C7.74432 5.48864 7.82386 5.12784 7.82386 4.73011C7.82386 4.28125 7.71875 3.89205 7.50852 3.5625C7.2983 3.23295 7.0142 2.97727 6.65625 2.79546C6.30398 2.61364 5.90909 2.52273 5.47159 2.52273C5.06818 2.52273 4.68466 2.6108 4.32102 2.78693C3.96307 2.95739 3.66477 3.21875 3.42614 3.57102C3.19318 3.91761 3.0625 4.35795 3.03409 4.89205H0C0.0284091 3.8125 0.289773 2.90909 0.784091 2.18182C1.28409 1.45455 1.94318 0.909091 2.76136 0.545454C3.58523 0.181818 4.49432 0 5.48864 0C6.57386 0 7.52841 0.190341 8.35227 0.571023C9.18182 0.951705 9.8267 1.49432 10.2869 2.19886C10.7528 2.89773 10.9858 3.72727 10.9858 4.6875C10.9858 5.33523 10.8807 5.91477 10.6705 6.42614C10.4659 6.9375 10.1733 7.39205 9.79261 7.78977C9.41193 8.1875 8.96023 8.54261 8.4375 8.85511C7.97727 9.1392 7.59943 9.43466 7.30398 9.74148C7.0142 10.0483 6.7983 10.4091 6.65625 10.8239C6.51989 11.233 6.44886 11.7386 6.44318 12.3409V12.5625H3.60511ZM5.08807 17.8807C4.5767 17.8807 4.13636 17.6989 3.76705 17.3352C3.39773 16.9716 3.21307 16.5284 3.21307 16.0057C3.21307 15.4943 3.39773 15.0568 3.76705 14.6932C4.13636 14.3295 4.5767 14.1477 5.08807 14.1477C5.59375 14.1477 6.03125 14.3295 6.40057 14.6932C6.77557 15.0568 6.96307 15.4943 6.96307 16.0057C6.96307 16.3523 6.875 16.6676 6.69886 16.9517C6.52841 17.2358 6.30114 17.4631 6.01705 17.6335C5.73864 17.7983 5.42898 17.8807 5.08807 17.8807Z"
        fill="white"
      />
    </svg>
  );
};

// --------------POS-header-icons---------------

export const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289L12.5858 6L1 6C0.447714 6 -3.88832e-07 5.55229 -4.37114e-07 5C-4.85396e-07 4.44772 0.447714 4 0.999999 4L12.5858 4L10.2929 1.70711C9.90237 1.31658 9.90237 0.683418 10.2929 0.292894C10.6834 -0.097631 11.3166 -0.097631 11.7071 0.292894L15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711Z"
        fill="#333333"
      />
    </svg>
  );
};

// -------------modal-icons----------------

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.542893 0.542893C0.933417 0.152369 1.56658 0.152369 1.95711 0.542893L7.5 6.08579L13.0429 0.542893C13.4334 0.152369 14.0666 0.152369 14.4571 0.542893C14.8476 0.933417 14.8476 1.56658 14.4571 1.95711L8.91421 7.5L14.4571 13.0429C14.8476 13.4334 14.8476 14.0666 14.4571 14.4571C14.0666 14.8476 13.4334 14.8476 13.0429 14.4571L7.5 8.91421L1.95711 14.4571C1.56658 14.8476 0.933417 14.8476 0.542893 14.4571C0.152369 14.0666 0.152369 13.4334 0.542893 13.0429L6.08579 7.5L0.542893 1.95711C0.152369 1.56658 0.152369 0.933417 0.542893 0.542893Z"
        fill="#333333"
      />
    </svg>
  );
};

export const CautionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
    >
      <path
        d="M10.127 17.9967C7.37884 17.9967 4.62311 17.9891 1.87491 17.9967C1.10692 17.9967 0.51963 17.703 0.18081 17.0178C-0.112833 16.4306 -0.0300109 15.8583 0.29375 15.3012C1.11445 13.8932 1.92761 12.4777 2.74078 11.0621C4.68334 7.69654 6.62591 4.33846 8.56847 0.972856C9.11059 0.0392205 10.1195 -0.261952 10.9929 0.242512C11.279 0.408157 11.4899 0.641566 11.648 0.920151C14.4263 5.73139 17.2046 10.5351 19.9754 15.3463C20.6982 16.6037 19.8926 17.9891 18.4319 17.9967C15.6686 18.0042 12.8978 17.9967 10.127 17.9967Z"
        fill="#FF0000"
      />
      <path
        d="M11.2037 8.66782C11.2037 9.42076 11.2037 10.1662 11.2037 10.9191C11.2037 11.5967 10.8197 11.9657 10.127 11.9657C9.43435 11.9657 9.05035 11.5967 9.04282 10.9266C9.04282 9.41323 9.04282 7.90736 9.04282 6.39397C9.04282 5.72386 9.43435 5.36245 10.1346 5.36245C10.8047 5.36245 11.1962 5.73892 11.2037 6.38644C11.2113 7.1469 11.2037 7.90736 11.2037 8.66782Z"
        fill="white"
      />
      <path
        d="M11.2037 14.5708C11.2113 15.1807 10.7294 15.6701 10.127 15.6701C9.53976 15.6701 9.05035 15.1882 9.05035 14.6009C9.04282 13.9911 9.5247 13.5016 10.127 13.5016C10.7219 13.5016 11.1962 13.976 11.2037 14.5708Z"
        fill="white"
      />
    </svg>
  );
};

// -------------setting-page-icons----------------

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.55228 0 9 0.447715 9 1V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H7V1C7 0.447715 7.44772 0 8 0Z"
        fill="#fff"
      />
    </svg>
  );
};
export const AddSmallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.55228 0 9 0.447715 9 1V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H7V1C7 0.447715 7.44772 0 8 0Z"
        fill="#000"
      />
    </svg>
  );
};
export const TiltArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 1C1 0.447715 1.44772 0 2 0H11C11.5523 0 12 0.447715 12 1V10C12 10.5523 11.5523 11 11 11C10.4477 11 10 10.5523 10 10V3.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L8.58579 2H2C1.44772 2 1 1.55228 1 1Z"
        fill="#ffffff"
      />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.343133 0.343146C0.733658 -0.0473782 1.36682 -0.0473782 1.75735 0.343146L5.99999 4.58579L10.2426 0.343146C10.6332 -0.0473785 11.2663 -0.0473782 11.6568 0.343146C12.0474 0.73367 12.0474 1.36684 11.6568 1.75736L7.4142 6L11.6568 10.2426C12.0474 10.6332 12.0474 11.2663 11.6568 11.6569C11.2663 12.0474 10.6332 12.0474 10.2426 11.6569L5.99999 7.41421L1.75735 11.6569C1.36682 12.0474 0.733658 12.0474 0.343133 11.6569C-0.0473908 11.2663 -0.0473909 10.6332 0.343133 10.2426L4.58577 6L0.343133 1.75736C-0.0473909 1.36684 -0.0473908 0.73367 0.343133 0.343146Z"
        fill="#fff"
      />
    </svg>
  );
};
export const KeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9571 0.292893C13.3476 0.683417 13.3476 1.31658 12.9571 1.70711L12.9142 1.75001L13.7071 2.54289C14.0976 2.93342 14.0976 3.56658 13.7071 3.95711C13.3166 4.34763 12.6834 4.34763 12.2929 3.95711L11.5 3.16422L10.6642 4.00001L11.4571 4.79289C11.8476 5.18342 11.8476 5.81658 11.4571 6.20711C11.0666 6.59763 10.4334 6.59763 10.0429 6.20711L9.25001 5.41422L7.44619 7.21804C7.79807 7.81355 8 8.50819 8 9.25C8 11.4591 6.20914 13.25 4 13.25C1.79086 13.25 0 11.4591 0 9.25C0 7.04086 1.79086 5.25 4 5.25C4.74181 5.25 5.43646 5.45193 6.03197 5.80382L8.54001 3.29579C8.54097 3.29482 8.54193 3.29386 8.54289 3.29289C8.54386 3.29193 8.54483 3.29097 8.54579 3.29L10.79 1.04578C10.791 1.04482 10.7919 1.04385 10.7929 1.04289C10.7939 1.04193 10.7948 1.04097 10.7958 1.04002L11.5429 0.292893C11.9334 -0.0976311 12.5666 -0.0976311 12.9571 0.292893ZM4 7.25C2.89543 7.25 2 8.14543 2 9.25C2 10.3546 2.89543 11.25 4 11.25C5.10457 11.25 6 10.3546 6 9.25C6 8.14543 5.10457 7.25 4 7.25Z"
        fill="#333333"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H8.5C9.16304 0 9.79893 0.263392 10.2678 0.732233C10.7366 1.20107 11 1.83696 11 2.5V3H11.5C12.8807 3 14 4.11929 14 5.5V11.5C14 12.8807 12.8807 14 11.5 14H5.5C4.11929 14 3 12.8807 3 11.5V11H2.5C1.83696 11 1.20107 10.7366 0.732233 10.2678C0.263392 9.79893 0 9.16304 0 8.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233ZM5 11.5C5 11.7761 5.22386 12 5.5 12H11.5C11.7761 12 12 11.7761 12 11.5V5.5C12 5.22386 11.7761 5 11.5 5H5.5C5.22386 5 5 5.22386 5 5.5V11.5ZM9 3H5.5C4.11929 3 3 4.11929 3 5.5V9H2.5C2.36739 9 2.24022 8.94732 2.14645 8.85355C2.05268 8.75978 2 8.63261 2 8.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H8.5C8.63261 2 8.75978 2.05268 8.85355 2.14645C8.94732 2.24022 9 2.36739 9 2.5V3Z"
        fill="#333333"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7087 0.907224C14.29 0.326327 15.0782 0 15.9 0C16.7222 0 17.5107 0.326617 18.0921 0.908C18.6735 1.48938 19.0001 2.27791 19.0001 3.10011C19.0001 3.92207 18.6737 4.71039 18.0926 5.29172C18.0924 5.29189 18.0928 5.29156 18.0926 5.29172L16.8287 6.56017C16.7936 6.61201 16.753 6.66129 16.7071 6.70721C16.6621 6.75226 16.6138 6.79211 16.563 6.82676L9.70837 13.7059C9.52073 13.8943 9.26584 14.0001 9 14.0001H6C5.44772 14.0001 5 13.5524 5 13.0001V10.0001C5 9.73427 5.10585 9.47938 5.29416 9.29174L12.1733 2.43708C12.208 2.38632 12.2478 2.33805 12.2929 2.293C12.3388 2.24708 12.3881 2.20655 12.4399 2.17143L13.7079 0.908C13.7082 0.907742 13.7084 0.907483 13.7087 0.907224ZM13.0112 4.42556L7 10.4154V12.0001H8.58474L14.5745 5.98887L13.0112 4.42556ZM15.9862 4.57213L14.428 3.01387L15.1221 2.32221C15.3284 2.1159 15.6082 2 15.9 2C16.1918 2 16.4716 2.1159 16.6779 2.32221C16.8842 2.52852 17.0001 2.80834 17.0001 3.10011C17.0001 3.39187 16.8842 3.67169 16.6779 3.878L15.9862 4.57213ZM0.87868 4.87879C1.44129 4.31618 2.20435 4.00011 3 4.00011H4C4.55228 4.00011 5 4.44782 5 5.00011C5 5.55239 4.55228 6.00011 4 6.00011H3C2.73478 6.00011 2.48043 6.10546 2.29289 6.293C2.10536 6.48054 2 6.73489 2 7.00011V16.0001C2 16.2653 2.10536 16.5197 2.29289 16.7072C2.48043 16.8948 2.73478 17.0001 3 17.0001H12C12.2652 17.0001 12.5196 16.8948 12.7071 16.7072C12.8946 16.5197 13 16.2653 13 16.0001V15.0001C13 14.4478 13.4477 14.0001 14 14.0001C14.5523 14.0001 15 14.4478 15 15.0001V16.0001C15 16.7958 14.6839 17.5588 14.1213 18.1214C13.5587 18.684 12.7957 19.0001 12 19.0001H3C2.20435 19.0001 1.44129 18.684 0.87868 18.1214C0.31607 17.5588 0 16.7958 0 16.0001V7.00011C0 6.20446 0.31607 5.4414 0.87868 4.87879Z"
        fill="#333333"
      />
    </svg>
  );
};

// -------------Payment-page-icons----------------

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 0.292893C17.0976 0.683417 17.0976 1.31658 16.7071 1.70711L6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071L0.292893 6.70711C-0.0976311 6.31658 -0.0976311 5.68342 0.292893 5.29289C0.683417 4.90237 1.31658 4.90237 1.70711 5.29289L6 9.58579L15.2929 0.292893C15.6834 -0.0976311 16.3166 -0.0976311 16.7071 0.292893Z"
        fill="#333333"
      />
    </svg>
  );
};

// -------------Table-icons----------------

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4H17C17.5523 4 18 3.55228 18 3C18 2.44771 17.5523 2 17 2H3ZM0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3C20 4.30622 19.1652 5.41746 18 5.82929V15C18 15.7957 17.6839 16.5587 17.1213 17.1213C16.5587 17.6839 15.7957 18 15 18H5C4.20435 18 3.44129 17.6839 2.87868 17.1213C2.31607 16.5587 2 15.7956 2 15V5.82929C0.834808 5.41746 0 4.30622 0 3ZM4 6V15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H15C15.2652 16 15.5196 15.8946 15.7071 15.7071C15.8946 15.5196 16 15.2652 16 15V6H4ZM7 9C7 8.44772 7.44772 8 8 8H12C12.5523 8 13 8.44772 13 9C13 9.55229 12.5523 10 12 10H8C7.44772 10 7 9.55229 7 9Z"
        fill="#333333"
      />
    </svg>
  );
};

//--------blockchain-icons----------
export const SolanaUsdcIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 20C15.5417 20 20 15.5417 20 10C20 4.4583 15.5417 0 10 0C4.4583 0 0 4.4583 0 10C0 15.5417 4.4583 20 10 20Z"
        fill="#2775CA"
      />
      <path
        d="M12.75 11.5833C12.75 10.125 11.875 9.62495 10.125 9.41665C8.87499 9.24995 8.62499 8.91665 8.62499 8.33325C8.62499 7.74985 9.04169 7.37495 9.87499 7.37495C10.625 7.37495 11.0417 7.62495 11.25 8.24995C11.2917 8.37495 11.4167 8.45825 11.5417 8.45825H12.2083C12.375 8.45825 12.5 8.33325 12.5 8.16665V8.12495C12.3333 7.20825 11.5833 6.49995 10.625 6.41665V5.41665C10.625 5.24995 10.5 5.12495 10.2917 5.08325H9.66669C9.49999 5.08325 9.37499 5.20825 9.33329 5.41665V6.37495C8.08329 6.54165 7.29169 7.37495 7.29169 8.41665C7.29169 9.79165 8.12499 10.3333 9.87499 10.5417C11.0417 10.75 11.4167 11 11.4167 11.6667C11.4167 12.3334 10.8333 12.7917 10.0417 12.7917C8.95829 12.7917 8.58329 12.3333 8.45829 11.7083C8.41669 11.5417 8.29169 11.4583 8.16669 11.4583H7.45829C7.29169 11.4583 7.16669 11.5833 7.16669 11.75V11.7917C7.33329 12.8333 7.99999 13.5833 9.37499 13.7917V14.7917C9.37499 14.9583 9.49999 15.0833 9.70829 15.125H10.3333C10.5 15.125 10.625 15 10.6667 14.7917V13.7917C11.9167 13.5833 12.75 12.7083 12.75 11.5833Z"
        fill="white"
      />
      <path
        d="M7.87502 15.9583C4.62502 14.7917 2.95832 11.1667 4.16672 7.95835C4.79172 6.20835 6.16672 4.87505 7.87502 4.25005C8.04172 4.16675 8.12502 4.04175 8.12502 3.83335V3.25005C8.12502 3.08335 8.04172 2.95835 7.87502 2.91675C7.83332 2.91675 7.75002 2.91675 7.70832 2.95835C3.75002 4.20835 1.58332 8.41675 2.83332 12.375C3.58332 14.7083 5.37502 16.5 7.70832 17.25C7.87502 17.3333 8.04172 17.25 8.08332 17.0833C8.12502 17.0417 8.12502 17 8.12502 16.9167V16.3333C8.12502 16.2083 8.00002 16.0417 7.87502 15.9583ZM12.2917 2.95835C12.125 2.87505 11.9583 2.95835 11.9167 3.12505C11.875 3.16675 11.875 3.20835 11.875 3.29175V3.87505C11.875 4.04175 12 4.20835 12.125 4.29175C15.375 5.45835 17.0417 9.08335 15.8333 12.2917C15.2083 14.0417 13.8333 15.375 12.125 16C11.9583 16.0833 11.875 16.2083 11.875 16.4167V17C11.875 17.1667 11.9583 17.2917 12.125 17.3333C12.1667 17.3333 12.25 17.3333 12.2917 17.2917C16.25 16.0417 18.4167 11.8333 17.1667 7.87505C16.4167 5.50005 14.5833 3.70835 12.2917 2.95835Z"
        fill="white"
      />
    </svg>
  );
};
export const CkBtcIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="url(#paint0_linear_742_84)"
      />
      <path
        d="M17.837 9.46667C17.5704 5.57037 14.4296 2.42963 10.5333 2.16296L10.5926 1.27407C14.9333 1.57037 18.4296 5.06667 18.7259 9.40741L17.837 9.46667Z"
        fill="url(#paint1_linear_742_84)"
      />
      <path
        d="M2.16296 9.46667L1.27407 9.40741C1.57037 5.06667 5.06666 1.57037 9.4074 1.27407L9.46666 2.16296C5.57037 2.41482 2.42963 5.55556 2.16296 9.46667Z"
        fill="url(#paint2_linear_742_84)"
      />
      <path
        d="M9.4074 18.7259C5.06666 18.4296 1.57037 14.9333 1.27407 10.5926L2.16296 10.5333C2.42963 14.4296 5.57037 17.5704 9.46666 17.837L9.4074 18.7259Z"
        fill="url(#paint3_linear_742_84)"
      />
      <path
        d="M10.5926 18.7259L10.5333 17.837C14.4296 17.5704 17.5704 14.4296 17.837 10.5333L18.7259 10.5926C18.4296 14.9333 14.9333 18.4296 10.5926 18.7259Z"
        fill="url(#paint4_linear_742_84)"
      />
      <path
        d="M12.4593 5.28889C12.4444 5.36296 12.4296 5.42222 12.4148 5.4963C12.3259 5.91111 12.2222 6.31111 12.1185 6.72593C12.1037 6.8 12.1185 6.82963 12.1926 6.84445C12.6074 6.99259 13.0074 7.15556 13.363 7.42222C13.8963 7.83704 14.0889 8.37037 13.9704 9.02222C13.8963 9.36296 13.7778 9.67408 13.5259 9.91111C13.3778 10.0444 13.2148 10.1481 13.037 10.2074C12.9778 10.2222 12.9333 10.237 12.8593 10.2667C12.9481 10.3259 13.037 10.3704 13.1111 10.4148C13.4667 10.6519 13.763 10.9481 13.837 11.3926C13.8815 11.5852 13.8667 11.8074 13.8518 12.0148C13.8074 12.4 13.6741 12.7556 13.4667 13.0667C13.1556 13.5407 12.7111 13.7926 12.1481 13.8667C11.6444 13.9407 11.1556 13.8815 10.6518 13.8074C10.4741 13.7778 10.5037 13.7778 10.4593 13.9259C10.3556 14.3556 10.2518 14.7704 10.163 15.2C10.1481 15.2296 10.1481 15.2741 10.1333 15.3037C9.82222 15.2296 9.52592 15.1556 9.2 15.0815C9.31851 14.5778 9.43703 14.0889 9.55555 13.5704C9.3037 13.5111 9.06666 13.4519 8.82963 13.3926C8.71111 13.8963 8.59259 14.4 8.47407 14.9037C8.16296 14.8296 7.85185 14.7556 7.54074 14.6815C7.65926 14.1778 7.77777 13.6741 7.89629 13.1556C7.27407 13.0074 6.65185 12.8593 6.02963 12.7111C6.17777 12.3556 6.32592 12 6.47407 11.6593C6.5037 11.6593 6.54814 11.6741 6.57777 11.6741C6.77037 11.7185 6.96296 11.763 7.14074 11.8074C7.34814 11.8519 7.51111 11.763 7.57037 11.5407C7.57037 11.5111 7.58518 11.4963 7.58518 11.4667C7.89629 10.1481 8.2074 8.82963 8.51851 7.52593C8.59259 7.2 8.45926 6.97778 8.14814 6.88889C8.02963 6.85926 7.91111 6.82963 7.79259 6.8C7.67407 6.77037 7.57037 6.74074 7.43703 6.71111C7.51111 6.38519 7.58518 6.05926 7.67407 5.71852C8.29629 5.86667 8.9037 6.01482 9.52592 6.16296C9.64444 5.64445 9.76296 5.14074 9.88148 4.65185C10.1926 4.72593 10.4889 4.8 10.8 4.87408C10.8 4.91852 10.7852 4.94815 10.7852 4.99259C10.6815 5.40741 10.5926 5.82222 10.4889 6.25185C10.4741 6.2963 10.4741 6.32593 10.4593 6.35556C10.7111 6.41482 10.9481 6.47408 11.2 6.53333C11.3185 6.02963 11.437 5.54074 11.5556 5.05185C11.837 5.15556 12.1481 5.21482 12.4593 5.28889ZM9.55555 10.2519C9.39259 10.9333 9.22963 11.6148 9.08148 12.2815C9.09629 12.2963 9.11111 12.2963 9.12592 12.2963C9.49629 12.3704 9.88148 12.4741 10.2518 12.5333C10.5926 12.5926 10.9185 12.5926 11.2593 12.5185C11.837 12.3704 12.1037 11.7481 11.7926 11.2296C11.6593 10.9926 11.437 10.8741 11.2 10.7556C10.6963 10.4741 10.1333 10.3852 9.55555 10.2519ZM9.77777 9.34815C10.1185 9.40741 10.4444 9.4963 10.7704 9.54074C11.0222 9.57037 11.2741 9.57037 11.5111 9.52593C12.1926 9.39259 12.3111 8.6963 12.0444 8.28148C11.8963 8.05926 11.6889 7.94074 11.4518 7.83704C11.0815 7.67408 10.6963 7.6 10.3111 7.51111C10.237 7.4963 10.2074 7.51111 10.1778 7.58519C10.0444 8.13333 9.92592 8.68148 9.79259 9.24445C9.79259 9.25926 9.79259 9.28889 9.77777 9.34815Z"
        fill="#FDFBFD"
      />
      <defs>
        <linearGradient
          id="paint0_linear_742_84"
          x1="20"
          y1="9.99999"
          x2="0"
          y2="9.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00558659" stopColor="#3B01B4" />
          <stop offset="1" stopColor="#3E00B5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_742_84"
          x1="-0.000759494"
          y1="9.99222"
          x2="20.0036"
          y2="9.99222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAB146" />
          <stop offset="1" stopColor="#DE4C3F" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_742_84"
          x1="-0.00253165"
          y1="9.99013"
          x2="19.9953"
          y2="9.99013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BA1E2" />
          <stop offset="1" stopColor="#24ABE7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_742_84"
          x1="-0.00358047"
          y1="10.0042"
          x2="19.9847"
          y2="10.0042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A239E" />
          <stop offset="1" stopColor="#D100AC" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_742_84"
          x1="0.0158409"
          y1="10.0115"
          x2="20.0032"
          y2="10.0115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BA1E2" />
          <stop offset="1" stopColor="#24ABE7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const SuiIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.48 8.352C13.312 9.376 13.76 10.656 13.76 12.064C13.76 13.472 13.248 14.816 12.416 15.84L12.352 15.904V15.776C12.352 15.712 12.288 15.584 12.288 15.456C11.84 13.6 10.496 12.064 8.256 10.784C6.72 9.952 5.888 8.864 5.632 7.712C5.504 6.944 5.568 6.176 5.824 5.536C6.016 4.896 6.336 4.32 6.592 4L7.488 2.912C7.616 2.72 7.936 2.72 8.064 2.912L12.48 8.352ZM13.888 7.264L8.064 0.096C7.936 -0.032 7.744 -0.032 7.616 0.096L1.728 7.264C0.64 8.608 0 10.336 0 12.192C0 16.48 3.52 20 7.808 20C12.096 20 15.616 16.544 15.616 12.192C15.616 10.336 14.976 8.608 13.888 7.264ZM3.136 8.288L3.648 7.648V7.776C3.648 7.84 3.648 7.968 3.712 8.032C4.032 9.824 5.248 11.296 7.296 12.448C9.024 13.472 10.048 14.624 10.368 15.84C10.496 16.352 10.496 16.864 10.432 17.312C9.664 17.696 8.768 17.888 7.808 17.888C4.48 17.888 1.856 15.2 1.856 11.936C1.792 10.656 2.304 9.312 3.136 8.288Z"
        fill="#4CA3FF"
      />
    </svg>
  );
};
export const AptosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.4097 6.64646H13.6408C13.4367 6.64646 13.2326 6.5444 13.0966 6.40834L12.3822 5.59191C12.1781 5.35379 11.8039 5.35379 11.5998 5.5579L11.5658 5.59191L10.9535 6.27223C10.7494 6.5104 10.4773 6.64646 10.1711 6.64646H0.510258C0.238121 7.42886 0.0680343 8.27926 0 9.12965H9.11656C9.28662 9.12965 9.42268 9.06165 9.52474 8.9596L10.3412 8.07514C10.4432 7.97308 10.5793 7.90508 10.7494 7.90508H10.7834C10.9535 7.90508 11.0895 7.97308 11.1916 8.10914L11.9059 8.9256C12.042 9.09565 12.2461 9.16371 12.4502 9.16371H19.8659C19.7979 8.31326 19.6278 7.49685 19.3556 6.68046H15.4097V6.64646ZM5.47674 14.3003C5.64679 14.3003 5.78291 14.2322 5.88497 14.1302L6.73537 13.2457C6.83742 13.1437 6.97348 13.0757 7.14359 13.0757H7.17759C7.34765 13.0757 7.48376 13.1437 7.58576 13.2798L8.30016 14.0962C8.43622 14.2662 8.64034 14.3343 8.84439 14.3343H18.9134C19.2876 13.5519 19.5598 12.7015 19.7299 11.851H10.069C9.86491 11.851 9.66085 11.749 9.52474 11.6129L8.81039 10.7965C8.70834 10.6605 8.53828 10.5924 8.40222 10.5924C8.23211 10.5924 8.09605 10.6605 7.99399 10.7965L7.38171 11.4769C7.17759 11.715 6.90542 11.817 6.59931 11.817H0.102052C0.272138 12.6674 0.544275 13.5179 0.918463 14.3003H5.47674ZM12.6203 3.9591C12.7904 3.9591 12.9264 3.89106 13.0285 3.78901L13.8789 2.90457C13.981 2.80252 14.1171 2.73448 14.2871 2.73448H14.3211C14.4912 2.73448 14.6273 2.80252 14.7294 2.93859L15.4437 3.75499C15.5798 3.89106 15.7839 3.99311 15.988 3.99311H17.893C14.5933 -0.429095 8.30016 -1.31354 3.91195 2.02013C3.16358 2.59842 2.48324 3.24474 1.93897 3.99311H12.6203V3.9591ZM8.77639 16.7835H6.15708C5.95297 16.7835 5.74885 16.6814 5.61279 16.5454L4.89845 15.729C4.69434 15.4909 4.32016 15.4909 4.08204 15.695L4.04802 15.729L3.43571 16.4433C3.23161 16.6814 2.95948 16.8175 2.65333 16.8175H2.61931C6.39519 20.8655 12.6883 21.0697 16.7363 17.3278C16.9064 17.1577 17.0765 16.9876 17.2466 16.8175L8.77639 16.7835Z"
        fill="black"
      />
    </svg>
  );
};
export const SolanaIcon = () => {
  return (
    <svg
      width="101"
      height="88"
      viewBox="0 0 101 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100.48 69.3817L83.8068 86.8015C83.4444 87.1799 83.0058 87.4816 82.5185 87.6878C82.0312 87.894 81.5055 88.0003 80.9743 88H1.93563C1.55849 88 1.18957 87.8926 0.874202 87.6912C0.558829 87.4897 0.31074 87.2029 0.160416 86.8659C0.0100923 86.529 -0.0359181 86.1566 0.0280382 85.7945C0.0919944 85.4324 0.263131 85.0964 0.520422 84.8278L17.2061 67.408C17.5676 67.0306 18.0047 66.7295 18.4904 66.5234C18.9762 66.3172 19.5002 66.2104 20.0301 66.2095H99.0644C99.4415 66.2095 99.8104 66.3169 100.126 66.5183C100.441 66.7198 100.689 67.0067 100.84 67.3436C100.99 67.6806 101.036 68.0529 100.972 68.415C100.908 68.7771 100.737 69.1131 100.48 69.3817ZM83.8068 34.3032C83.4444 33.9248 83.0058 33.6231 82.5185 33.4169C82.0312 33.2108 81.5055 33.1045 80.9743 33.1048H1.93563C1.55849 33.1048 1.18957 33.2121 0.874202 33.4136C0.558829 33.6151 0.31074 33.9019 0.160416 34.2388C0.0100923 34.5758 -0.0359181 34.9482 0.0280382 35.3103C0.0919944 35.6723 0.263131 36.0083 0.520422 36.277L17.2061 53.6968C17.5676 54.0742 18.0047 54.3752 18.4904 54.5814C18.9762 54.7875 19.5002 54.8944 20.0301 54.8952H99.0644C99.4415 54.8952 99.8104 54.7879 100.126 54.5864C100.441 54.3849 100.689 54.0981 100.84 53.7612C100.99 53.4242 101.036 53.0518 100.972 52.6897C100.908 52.3277 100.737 51.9917 100.48 51.723L83.8068 34.3032ZM1.93563 21.7905H80.9743C81.5055 21.7907 82.0312 21.6845 82.5185 21.4783C83.0058 21.2721 83.4444 20.9704 83.8068 20.592L100.48 3.17219C100.737 2.90357 100.908 2.56758 100.972 2.2055C101.036 1.84342 100.99 1.47103 100.84 1.13408C100.689 0.79713 100.441 0.510296 100.126 0.308823C99.8104 0.107349 99.4415 1.24074e-05 99.0644 0L20.0301 0C19.5002 0.000878397 18.9762 0.107699 18.4904 0.313848C18.0047 0.519998 17.5676 0.821087 17.2061 1.19848L0.524723 18.6183C0.267681 18.8866 0.0966198 19.2223 0.0325185 19.5839C-0.0315829 19.9456 0.0140624 20.3177 0.163856 20.6545C0.31365 20.9913 0.561081 21.2781 0.875804 21.4799C1.19053 21.6817 1.55886 21.7896 1.93563 21.7905Z"
        fill="url(#paint0_linear_174_4403)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_174_4403"
          x1="8.52558"
          y1="90.0973"
          x2="88.9933"
          y2="-3.01622"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#9945FF" />
          <stop offset="0.3" stopColor="#8752F3" />
          <stop offset="0.5" stopColor="#5497D5" />
          <stop offset="0.6" stopColor="#43B4CA" />
          <stop offset="0.72" stopColor="#28E0B9" />
          <stop offset="0.97" stopColor="#19FB9B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const VenomIcon = () => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.406.04a3.282 3.282 0 0 0-1.543.132 3.14 3.14 0 0 0-1.287.82c-.668.71-.876 1.636-.716 2.563.146.837.338 1.686.382 2.492a8.735 8.735 0 0 1-.572 3.568c-.397 1.033-.961 1.834-2.172 2.011-.09.014-.416.023-.51.028a4.166 4.166 0 0 1-.476-.027c-1.21-.177-1.78-.978-2.176-2.018a8.734 8.734 0 0 1-.572-3.568c.044-.803.236-1.653.382-2.491.16-.928-.048-1.854-.715-2.565A3.142 3.142 0 0 0 4.14.168 3.283 3.283 0 0 0 2.594.04C1.043.28.01 1.589 0 2.962a2.735 2.735 0 0 0 .437 1.5c.483.758 1.276 1.31 1.968 1.883.458.383 1.25 1.47 1.638 2.649.235.714.426 1.437.616 2.167.266 1.018.632 3.266.873 4.286.481 2.043 1.954 2.506 3.43 2.553h.052c1.476-.047 2.973-.51 3.454-2.554.24-1.02.605-3.269.873-4.286.19-.726.381-1.453.616-2.167.389-1.179 1.18-2.27 1.638-2.65.692-.574 1.484-1.124 1.968-1.881.29-.452.441-.972.437-1.5C17.992 1.584 16.962.274 15.406.04Z"
        fill="#333333"
      />
    </svg>
  );
};
export const ICPIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="20"
      viewBox="0 0 40 20"
      fill="none"
    >
      <path
        d="M30.2113 0C27.9867 0 25.5506 1.21246 22.9811 3.604C21.7686 4.72748 20.7008 5.95106 19.9221 6.9188C19.9221 6.9188 21.168 8.35373 22.5361 9.89989C23.2814 8.96552 24.3382 7.69744 25.5729 6.55172C27.8532 4.41602 29.3437 3.9822 30.2002 3.9822C33.4038 3.9822 36.0067 6.67408 36.0067 10C36.0067 13.2925 33.4038 15.9844 30.2002 16.0178C30.0445 16.0178 29.8665 15.9955 29.644 15.9511C30.5784 16.3849 31.5907 16.6963 32.5361 16.6963C38.4093 16.6963 39.5662 12.6363 39.6329 12.3471C39.7998 11.6018 39.8999 10.8231 39.8999 10.0222C39.8888 4.49388 35.5506 0 30.2113 0Z"
        fill="url(#paint0_linear_835_76)"
      />
      <path
        d="M9.68854 20C11.9132 20 14.3493 18.7875 16.9188 16.396C18.1313 15.2725 19.1991 14.0489 19.9778 13.0812C19.9778 13.0812 18.7319 11.6463 17.3637 10.1001C16.6185 11.0345 15.5617 12.3026 14.327 13.4483C12.0467 15.5617 10.5451 16.0178 9.69967 16.0178C6.49611 16.0178 3.89321 13.3259 3.89321 10C3.89321 6.70745 6.49611 4.01557 9.69967 3.9822C9.85539 3.9822 10.0334 4.00445 10.2558 4.04894C9.32147 3.61513 8.30923 3.30367 7.36374 3.30367C1.49054 3.29255 0.333704 7.35261 0.266963 7.65295C0.100111 8.39822 0 9.17686 0 9.97775C0 15.5061 4.33815 20 9.68854 20Z"
        fill="url(#paint1_linear_835_76)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1602 6.64071C13.515 6.0178 10.3782 3.47052 7.37486 3.38153C2.01334 3.24805 0.444933 7.14127 0.300328 7.64182C1.33481 3.28142 5.16129 0.0222469 9.69966 0C13.4038 0 17.1524 3.63737 19.9221 6.9188L19.9333 6.90767C19.9333 6.90767 21.1791 8.3426 22.5473 9.88877C22.5473 9.88877 24.1046 11.7241 25.7508 13.337C26.396 13.96 29.5217 16.4739 32.525 16.5628C38.0311 16.7186 39.5551 12.6029 39.6329 12.2914C38.6207 16.6852 34.7831 19.9555 30.2225 19.9778C26.5183 19.9778 22.7697 16.3404 19.9889 13.059C19.9889 13.0701 19.9778 13.0701 19.9778 13.0812C19.9778 13.0812 18.7319 11.6463 17.3637 10.1001C17.3749 10.1001 15.8176 8.25361 14.1602 6.64071Z"
        fill="#29ABE2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_835_76"
          x1="10.1494"
          y1="1.89825"
          x2="24.5851"
          y2="26.165"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#F15A24" />
          <stop offset="0.6841" stopColor="#FBB03B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_835_76"
          x1="29.7574"
          y1="18.1044"
          x2="15.3218"
          y2="-6.16225"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#ED1E79" />
          <stop offset="0.8929" stopColor="#522785" />
        </linearGradient>
      </defs>
    </svg>
  );
};
